import ALoading from './index.vue';

ALoading.install = app => {
  app.component(ALoading.name, ALoading);
};

export default ALoading;
